<template>
  <div v-if="emailSent">
    <alert class="success">
      <Icon
        slot="icon"
        type="check"
        :size="2"
        padding=".5em"
        :rounded="true"
        backgroundColor="transparent"
      />
      <p>
        If your account exists, an E-mail will be sent to your e-mail account.
      </p>
      <p>
        Please check your E-mail for further instructions.
      </p>
    </alert>
    <Divider />
    <alert class="info">
      <Icon
        slot="icon"
        type="info"
        :size="2"
        padding=".5em"
        :rounded="true"
        backgroundColor="transparent"
      />
      <p>
        <strong
          >If you can't find the E-mail in your Inbox, please check your spam
          folder.</strong
        >
      </p>
    </alert>
  </div>
  <form v-else v-on:submit.prevent="onSubmit">
    <SectionHeader>
      <h1>Activate Account</h1>
    </SectionHeader>
    <SectionWrapper class="whiteframe shadowframe">
      <p>
        Enter your account E-mail address.
      </p>
      <FieldWrapper>
        <input
          class="input"
          type="email"
          v-model="user.email"
          name="email"
          tabindex="1"
          placeholder="E-mail"
          v-validate="validatorDefinitions.email"
          data-vv-scope="activation-resend"
          autofocus
        />
      </FieldWrapper>
      <DecoratedButton type="submit" class="wide" :loading="loading">
        CONTINUE
      </DecoratedButton>
    </SectionWrapper>
  </form>
</template>

<script>
export default {
  name: "form-password-reminder",
  data: function() {
    return {
      user: {
        email: ""
      },
      emailSent: false,
      loading: false
    };
  },
  methods: {
    onSubmit() {
      this.$validator.validateAll("activation-resend").then(valid => {
        if (valid) {
          this.loading = true;
          this.services.UserResource.sendActivationEmail(this.user)
            .then(() => {
              this.loading = false;
              this.emailSent = true;
            })
            .catch(err => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.input {
  text-align: center;
}
</style>
